export const LIST_ADMISSION_REQUEST = 'LIST_ADMISSION_REQUEST'
export const LIST_ADMISSION_SUCCESS = 'LIST_ADMISSION_SUCCESS'
export const LIST_ADMISSION_FAIL = 'LIST_ADMISSION_FAIL'
export const LIST_ADMISSION_RESET = 'LIST_ADMISSION_RESET'

export const LIST_ADMISSION_PACKAGE_REQUEST = 'LIST_ADMISSION_PACKAGE_REQUEST'
export const LIST_ADMISSION_PACKAGE_SUCCESS = 'LIST_ADMISSION_PACKAGE_SUCCESS'
export const LIST_ADMISSION_PACKAGE_FAIL = 'LIST_ADMISSION_PACKAGE_FAIL'

export const LIST_ADMISSION_MS_PACKAGE_REQUEST = 'LIST_ADMISSION_MS_PACKAGE_REQUEST'
export const LIST_ADMISSION_MS_PACKAGE_SUCCESS = 'LIST_ADMISSION_MS_PACKAGE_SUCCESS'
export const LIST_ADMISSION_MS_PACKAGE_FAIL = 'LIST_ADMISSION_MS_PACKAGE_FAIL'

export const LIST_ADMISSION_MS_SERVICE_REQUEST = 'LIST_ADMISSION_MS_SERVICE_REQUEST'
export const LIST_ADMISSION_MS_SERVICE_SUCCESS = 'LIST_ADMISSION_MS_SERVICE_SUCCESS'
export const LIST_ADMISSION_MS_SERVICE_FAIL = 'LIST_ADMISSION_MS_SERVICE_FAIL'

export const LIST_ADMISSION_RSVP_LIST_REQUEST =
  'LIST_ADMISSION_RSVP_LIST_REQUEST'
export const LIST_ADMISSION_RSVP_LIST_SUCCESS =
  'LIST_ADMISSION_RSVP_LIST_SUCCESS'
export const LIST_ADMISSION_RSVP_LIST_FAIL = 'LIST_ADMISSION_RSVP_LIST_FAIL'
export const LIST_ADMISSION_RSVP_LIST_RESET = 'LIST_ADMISSION_RSVP_LIST_RESET'

export const CREATE_ADMISSION_REQUEST = 'CREATE_ADMISSION_REQUEST'
export const CREATE_ADMISSION_SUCCESS = 'CREATE_ADMISSION_SUCCESS'
export const CREATE_ADMISSION_FAIL = 'CREATE_ADMISSION_FAIL'

export const DETAIL_ADMISSION_REQUEST = 'DETAIL_ADMISSION_REQUEST'
export const DETAIL_ADMISSION_SUCCESS = 'DETAIL_ADMISSION_SUCCESS'
export const DETAIL_ADMISSION_FAIL = 'DETAIL_ADMISSION_FAIL'

export const DETAIL_ADMISSION_RSVP_REQUEST = 'DETAIL_ADMISSION_RSVP_REQUEST'
export const DETAIL_ADMISSION_RSVP_SUCCESS = 'DETAIL_ADMISSION_RSVP_SUCCESS'
export const DETAIL_ADMISSION_RSVP_FAIL = 'DETAIL_ADMISSION_RSVP_FAIL'

export const DETAIL_ADMISSION_MR_REQUEST = 'DETAIL_ADMISSION_MR_REQUEST'
export const DETAIL_ADMISSION_MR_SUCCESS = 'DETAIL_ADMISSION_MR_SUCCESS'
export const DETAIL_ADMISSION_MR_FAIL = 'DETAIL_ADMISSION_MR_FAIL'

export const LIST_ADMISSION_ADDITIONAL_INFO_REQUEST =
  'LIST_ADMISSION_ADDITIONAL_INFO_REQUEST'
export const LIST_ADMISSION_ADDITIONAL_INFO_SUCCESS =
  'LIST_ADMISSION_ADDITIONAL_INFO_SUCCESS'
export const LIST_ADMISSION_ADDITIONAL_INFO_FAIL =
  'LIST_ADMISSION_ADDITIONAL_INFO_FAIL'

export const DETAIL_PROJECT_BY_PACKAGE_REQUEST =
  'DETAIL_PROJECT_BY_PACKAGE_REQUEST'
export const DETAIL_PROJECT_BY_PACKAGE_SUCCESS =
  'DETAIL_PROJECT_BY_PACKAGE_SUCCESS'
export const DETAIL_PROJECT_BY_PACKAGE_FAIL = 'DETAIL_PROJECT_BY_PACKAGE_FAIL'

export const UPDATE_ADMISSION_REQUEST = 'UPDATE_ADMISSION_REQUEST'
export const UPDATE_ADMISSION_SUCCESS = 'UPDATE_ADMISSION_SUCCESS'
export const UPDATE_ADMISSION_FAIL = 'UPDATE_ADMISSION_FAIL'

export const DELETE_ADMISSION_REQUEST = 'DELETE_ADMISSION_REQUEST'
export const DELETE_ADMISSION_SUCCESS = 'DELETE_ADMISSION_SUCCESS'
export const DELETE_ADMISSION_FAIL = 'DELETE_ADMISSION_FAIL'

export const DISCHARGE_ADMISSION_REQUEST = 'DISCHARGE_ADMISSION_REQUEST'
export const DISCHARGE_ADMISSION_SUCCESS = 'DISCHARGE_ADMISSION_SUCCESS'
export const DISCHARGE_ADMISSION_FAIL = 'DISCHARGE_ADMISSION_FAIL'

export const CANCEL_DISCHARGE_ADMISSION_REQUEST = 'CANCEL_DISCHARGE_ADMISSION_REQUEST'
export const CANCEL_DISCHARGE_ADMISSION_SUCCESS = 'CANCEL_DISCHARGE_ADMISSION_SUCCESS'
export const CANCEL_DISCHARGE_ADMISSION_FAIL = 'CANCEL_DISCHARGE_ADMISSION_FAIL'

export const DETAIL_PRINT_INVOICE_PATIENT_REQUEST =
  'DETAIL_PRINT_INVOICE_PATIENT_REQUEST'
export const DETAIL_PRINT_INVOICE_PATIENT_SUCCESS =
  'DETAIL_PRINT_INVOICE_PATIENT_SUCCESS'
export const DETAIL_PRINT_INVOICE_PATIENT_FAIL =
  'DETAIL_PRINT_INVOICE_PATIENT_FAIL'

export const RESET_ADMISSION_FORM = 'RESET_ADMISSION_FORM'

export const LOG_HISTORY_ADMISSION_REQUEST = 'LOG_HISTORY_ADMISSION_REQUEST'
export const LOG_HISTORY_ADMISSION_SUCCESS = 'LOG_HISTORY_ADMISSION_SUCCESS'
export const LOG_HISTORY_ADMISSION_FAIL = 'LOG_HISTORY_ADMISSION_FAIL'

export const LIST_ADMISSION_REGISTRATION_REQUEST =
  'LIST_ADMISSION_REGISTRATION_REQUEST'
export const LIST_ADMISSION_REGISTRATION_SUCCESS =
  'LIST_ADMISSION_REGISTRATION_SUCCESS'
export const LIST_ADMISSION_REGISTRATION_FAIL =
  'LIST_ADMISSION_REGISTRATION_FAIL'

export const LIST_PRINT_HISTORY_RESULT_REQUEST = 'LIST_PRINT_HISTORY_RESULT_REQUEST'
export const LIST_PRINT_HISTORY_RESULT_SUCCESS = 'LIST_PRINT_HISTORY_RESULT_SUCCESS'
export const LIST_PRINT_HISTORY_RESULT_FAIL = 'LIST_PRINT_HISTORY_RESULT_FAIL'

export const PRINT_HISTORY_RESULT_REQUEST = 'PRINT_HISTORY_RESULT_REQUEST'
export const PRINT_HISTORY_RESULT_SUCCESS = 'PRINT_HISTORY_RESULT_SUCCESS'
export const PRINT_HISTORY_RESULT_FAIL = 'PRINT_HISTORY_RESULT_FAIL'

export const IMPORT_ADMISSION_DATA_REQUEST = 'IMPORT_ADMISSION_DATA_REQUEST'
export const IMPORT_ADMISSION_DATA_SUCCESS = 'IMPORT_ADMISSION_DATA_SUCCESS'
export const IMPORT_ADMISSION_DATA_FAIL = 'IMPORT_ADMISSION_DATA_FAIL'

export const LIST_IMPORT_ADMISSION_DATA_REQUEST = 'LIST_IMPORT_ADMISSION_DATA_REQUEST'
export const LIST_IMPORT_ADMISSION_DATA_SUCCESS = 'LIST_IMPORT_ADMISSION_DATA_SUCCESS'
export const LIST_IMPORT_ADMISSION_DATA_FAIL = 'LIST_IMPORT_ADMISSION_DATA_FAIL'

export const LIST_DETAIL_IMPORT_DATA_ADMISSION_REQUEST = 'LIST_DETAIL_IMPORT_DATA_ADMISSION_REQUEST'
export const LIST_DETAIL_IMPORT_DATA_ADMISSION_SUCCESS = 'LIST_DETAIL_IMPORT_DATA_ADMISSION_SUCCESS'
export const LIST_DETAIL_IMPORT_DATA_ADMISSION_FAIL = 'LIST_DETAIL_IMPORT_DATA_ADMISSION_FAIL'

export const DETAIL_IMPORT_DATA_ADMISSION_REQUEST = 'DETAIL_IMPORT_DATA_ADMISSION_REQUEST'
export const DETAIL_IMPORT_DATA_ADMISSION_SUCCESS = 'DETAIL_IMPORT_DATA_ADMISSION_SUCCESS'
export const DETAIL_IMPORT_DATA_ADMISSION_FAIL = 'DETAIL_IMPORT_DATA_ADMISSION_FAIL'

export const EXPORT_IMPORT_DATA_ADMISSION_REQUEST = 'EXPORT_IMPORT_DATA_ADMISSION_REQUEST'
export const EXPORT_IMPORT_DATA_ADMISSION_SUCCESS = 'EXPORT_IMPORT_DATA_ADMISSION_SUCCESS'
export const EXPORT_IMPORT_DATA_ADMISSION_FAIL = 'EXPORT_IMPORT_DATA_ADMISSION_FAIL'


export const RESET_DETAIL_PROJECT_BY_PACKAGE = 'RESET_DETAIL_PROJECT_BY_PACKAGE'

export const MEDICAL_INFO_SUMMARY_REQUEST = 'MEDICAL_INFO_SUMMARY_REQUEST'
export const MEDICAL_INFO_SUMMARY_SUCCESS = 'MEDICAL_INFO_SUMMARY_SUCCESS'
export const MEDICAL_INFO_SUMMARY_FAIL = 'MEDICAL_INFO_SUMMARY_FAIL'

export const MEDICAL_INFO_SUMMARY_OPTIONAL_REQUEST = 'MEDICAL_INFO_SUMMARY_OPTIONAL_REQUEST'
export const MEDICAL_INFO_SUMMARY_OPTIONAL_SUCCESS = 'MEDICAL_INFO_SUMMARY_OPTIONAL_SUCCESS'
export const MEDICAL_INFO_SUMMARY_OPTIONAL_FAIL = 'MEDICAL_INFO_SUMMARY_OPTIONAL_FAIL'

export const GET_BRANCH_MAX_CAPACITY_REQUEST = 'GET_BRANCH_MAX_CAPACITY_REQUEST'
export const GET_BRANCH_MAX_CAPACITY_SUCCESS = 'GET_BRANCH_MAX_CAPACITY_SUCCESS'
export const GET_BRANCH_MAX_CAPACITY_FAIL = 'GET_BRANCH_MAX_CAPACITY_FAIL'

export const LIST_ADMISSION_ONLINE_RSVP_REQUEST = 'LIST_ADMISSION_ONLINE_RSVP_REQUEST'
export const LIST_ADMISSION_ONLINE_RSVP_SUCCESS = 'LIST_ADMISSION_ONLINE_RSVP_SUCCESS'
export const LIST_ADMISSION_ONLINE_RSVP_FAIL = 'LIST_ADMISSION_ONLINE_RSVP_FAIL'

export const GET_SUMMARY_RSVP_VISIT_TIME_REQUEST = 'GET_SUMMARY_RSVP_VISIT_TIME_REQUEST'
export const GET_SUMMARY_RSVP_VISIT_TIME_SUCCESS = 'GET_SUMMARY_RSVP_VISIT_TIME_SUCCESS'
export const GET_SUMMARY_RSVP_VISIT_TIME_FAIL = 'GET_SUMMARY_RSVP_VISIT_TIME_FAIL'
